// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';
import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';
import './dashboard.scss';
import { currentDealList } from '../../../redux/actions/frontActions';
import { get_static_page_details } from "../../../redux/actions/termsPolicyAndContactActions";
import noImg from '../../../img/no_img.jpg';
import ReactHtmlParser from 'react-html-parser';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import Reviews from './Reviews.js';
import ReviewList from './ReviewList.js';
import languageConfig from "../../../config/languageConfig";
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const history = createBrowserHistory();

let isLoading="false", limit=6;

class SearchDeal extends Component {
  
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props, context){
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList:'',
      currentDeals:[],
      limit: 6,
      perPage:6,
      total: '',
      searchText:'',
      hover: false,
      isLoading: true,
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      load_more: true,
    };

    this.pagination = this.pagination.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  pagination = () => {
    this.setState({load_more: true});
    isLoading = true;
    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }
    limit = limit + this.state.perPage;

    const postData = {
      cityID : this.state.default_city,
      geolocation: "off",
      limit: limit,
      search: this.state.searchText,
      lang: this.state.default_lang,
      default_lang:this.state.default_lang,
    };

    //this.props.currentDealList(postData);
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });
    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    //isLoading="true";
    //let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
     if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
  }

  this.setState({
      currentPage: page,
      cartTotal: 0
  });

  let searchText = (this.props.route && this.props.route.match.params && this.props.route.match.params.searchText) ? this.props.route.match.params.searchText : '';
  
  if (searchText !== '')
  {
      this.setState({searchText: this.props.route.match.params.searchText })
      const postData = {
        cityID : this.state.default_city,
        geolocation :"off",
        limit: limit,
        search: this.props.route.match.params.searchText,
        lang: this.state.default_lang,
        default_lang:this.state.default_lang
      }
      //this.props.currentDealList(postData);
  }
};

componentWillMount() { 
    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city){
        //this.setState({default_city: siteData.default_city, default_lang: siteData.default_lang});
      this.setState({multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: this.state.default_lang});

      }
    }
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }

    if(siteData.currency){
        this.setState({
          currency: siteData.currency, 
        });
      }

    let searchText = (this.props.route && this.props.route.match.params && this.props.route.match.params.searchText) ? this.props.route.match.params.searchText : '';
    if (searchText !== '')
    {
      this.setState({searchText: this.props.route.match.params.searchText })
      const postData = {
        cityID : default_city,
        geolocation :"off",
        latitude:'26.846695',
        longitude:'80.946167',
        limit: limit,
        search: this.props.route.match.params.searchText,
        lang: this.state.default_lang,
        default_lang: this.state.default_lang,
      }
      //this.props.currentDealList(postData);
    }

    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          text_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
}

componentDidMount() {
    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city){
        //this.setState({default_city: siteData.default_city, default_lang: siteData.default_lang});
      this.setState({multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: this.state.default_lang});

      }
    }
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }

    if(siteData.currency){
        this.setState({
          currency: siteData.currency, 
        });
      }

    let searchText = (this.props.route && this.props.route.match.params && this.props.route.match.params.searchText) ? this.props.route.match.params.searchText : '';
    if (searchText !== '')
    {
      this.setState({searchText: this.props.route.match.params.searchText })
      const postData = {
        cityID : default_city,
        geolocation :"off",
        latitude:'26.846695',
        longitude:'80.946167',
        limit: limit,
        search: this.props.route.match.params.searchText,
        lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
      }
      this.props.currentDealList(postData);
    }

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.language){
      if(this.state.default_lang !== nextProps.language){
        this.setState({default_lang: nextProps.language,lang: nextProps.language});
        this.props.get_static_page_details({default_lang: nextProps.language,lang: nextProps.language});
      }
    }
    
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if(nextProps.curDeal){
      isLoading="false";
      this.setState({total: nextProps.curDeal.total})
      this.setState({currentDeals: nextProps.curDeal.data, load_more: false})
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        isLoading='false';
      }
  }
}
 
render() {
    const { index, direction, width } = this.state;
    const isMobile = width >= 600;
    if(this.props.route.match && this.state.searchText != this.props.route.match.params.searchText && this.state.searchText != ''){
      this.handlePageChange(1)
    }
    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    //test
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    let default_currency;
    let french_default_currency;
    
    //console.log("a"+this.state.default_lang);

    if(this.state.default_lang == "en"){
      french_default_currency = "";
      default_currency = this.state.currency == 'EUR' ? '€' : '$';
    }else{
      default_currency = "";
      french_default_currency = this.state.currency == 'EUR' ? '€' : '$';
    }
    
    let currentDeals, totalDeal = 0;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!isEmpty(this.state.currentDeals)){
      totalDeal = this.state.currentDeals.length;
      currentDeals = this.state.currentDeals.map((deal, index) => 
        <Col lg={4} md={4} sm={4} xs={12} key={index}>
          <div className="deal-container shadow">
            <div className="deal-image">
              <Image src={deal.dealImage.includes('http') ? deal.dealImage : deal.imageurl +  deal.dealImage} responsive />
            </div>

            {(this.state.default_lang == "en") ? (<h2 className="dealname">{ReactHtmlParser((deal.searchmaindealText != '') ? deal.searchmaindealText : deal.searchdealText)}</h2>) : (<h2 className="dealname">{ReactHtmlParser((deal.french_mainDealText != '') ? deal.french_mainDealText : deal.french_dealText)}</h2>)}
            
            <div className="merchant">{deal.legalName} | {deal.merchantName}</div>
            
              {(deal.offerPrice > 0) ?
                <div className="prices">
                {deal.proposal_type != 10 && deal.proposal_type != 11 &&
                  <span className="percent" style={{ color: this.state.text_color }}>-{Math.round(100 - ((deal.offerPrice/deal.retailPrice)*100))}%</span>   
                }
                {deal.proposal_type != 10 && deal.proposal_type != 11 &&                 
                  <span className="price">{default_currency}{deal.retailPrice}{french_default_currency}</span>
                }
                {deal.proposal_type == 11 && deal.lastAuctionAmount > 0 ? (
                  <span className="current">{default_currency}{deal.lastAuctionAmount}{french_default_currency}</span>
                ) : (  
                  <span className="current">{default_currency}{deal.offerPrice}{french_default_currency}</span>
                )}
                </div>
              :
                <div className="prices">
                {deal.proposal_type == 7 ? (
                  <span className="percent" style={{ color: this.state.text_color }}>
                  {deal.percentageOff}% OFF
                  </span>
                  ) :
                  <span className="percent" style={{ color: this.state.text_color }}>
                  {
                    deal.proposal_type == 6
                    ? languageConfig[this.state.default_lang].proposal_coupon
                    : languageConfig[this.state.default_lang].free_text
                  }
                  </span>
                }
                </div>
              }

            <div className="short-disc">
            {(deal.writeUp) ? ReactHtmlParser(deal.writeUp.substring(0, 180).replace(/<[^>]+>/g, '')) : ''}
            </div>
            <div className="deal-footer">
            {(isIE == false && isEdge == false && isMobile) ?
              (deal.proposal_type == 11) ?
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/auction-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Auction Ended' : 'See Details'}</a>
              : (deal.proposal_type == 10) ?
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/store-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Sold Out' : 'See Details'}</a>
              :
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/deals-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Sold Out' : languageConfig[this.state.default_lang].view}</a>  
            :
            (deal.proposal_type == 11) ?
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/auction-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Auction Ended' : 'See Details'}</a>
              : (deal.proposal_type == 10) ?
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/store-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Sold Out' : 'See Details'}</a>
              :
              <a 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {deal.dealID}
                className="btn btn-deal" 
                onClick={() => this.context.router.history.push(`/deals-detail/${deal.dealID}/${(cookies.get('akash') ? cookies.get('akash') : siteData.default_city)}`)}>{(deal.sold_out && deal.sold_out=="true") ? 'Sold Out' : languageConfig[this.state.default_lang].view}</a>    
            }
            </div>
          </div>
        </Col>
      );
    }

    const style = {
      width: '100%',
      height: '100%'
    }
    
    return(
      <div>
        {(isLoading =='true') ?   
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        } 
        
          {(!isEmpty(this.state.currentDeals)) ?
          <div className="container">
              {/*<div className="heading"><h2>Deals</h2></div>*/}
              <Row> 
                {currentDeals}
              </Row>

              {(this.state.total > totalDeal) ?
              <Row>
                <Col lg={12} md={12} sm={12} xs={12} onClick={this.pagination} className="text-center">
                   <a 
                    className="btn btn-deal" 
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mouseover_color : this.state.button_color}}
                    data-id = {'Load More'}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                    >
                    {(this.state.load_more) ?
                    <React.Fragment> 
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> {languageConfig[this.state.default_lang].load_more_deals}
                    </React.Fragment> 
                    :
                    languageConfig[this.state.default_lang].load_more_deals
                    } 
                  </a> 
                </Col>
              </Row>
              : null}
          </div>
          : ''}
        
      </div>
    );
  }
}

SearchDeal.propTypes = {
  currentDealList: PropTypes.func.isRequired,
  get_static_page_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
})



export default connect(
  mapStateToProps,{currentDealList,get_static_page_details}
)(SearchDeal);




// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/SearchDeal.js